<template>
  <v-card flat class="card">
    <v-card-title>{{name}} <template v-if="verein">({{verein}})</template></v-card-title>
    <v-card-text v-if="name">
      <div class="platz">Zeit im Parcours:</div>
      <div class="time">{{timeformat}}</div>
      <div class="platz">Platz: {{platz}}</div>
    </v-card-text>
    <v-card-actions class="actions">
      <v-select v-model="buzz" label="Buzzer-Taste" :items="[
          { text: 'Leertaste', value: 'Space' },
          { text: 'Enter', value: 'Enter' },
          { text: 'Umschalt links', value: 'ShiftLeft' },
          { text: 'Umschalt rechts', value: 'ShiftRight' },
      ]" />
      <div class="flex-grow-1" />
      <v-btn @click="buzzer({code: buzz})" v-if="name && (!time || running)"><template v-if="!running">Start</template><template v-if="running">Stop</template></v-btn>
      <template v-if="name && time && !running">
        <v-btn @click="bonus">-5sec</v-btn>
        <v-btn @click="malus">+5sec</v-btn>
      </template>
      <div class="flex-grow-1" />
      <v-btn @click="neu(false)" v-if="name && time && !running">Neuer Versuch</v-btn>
      <v-btn @click="neu(true)">Neue Person</v-btn>
    </v-card-actions>
    <v-dialog v-model="dialog.open" @keydown.esc="dialog.open=false">
      <v-card flat>
        <v-card-title>Neuer Wettkämpfer</v-card-title>
        <v-card-text>
          <v-text-field v-model="dialog.name" label="Name" @keydown.enter="close(true)" />
          <!--v-text-field v-model="dialog.verein" label="Verein" /-->
          <v-radio-group v-model="dialog.mwd" row>
            <v-radio label="m" value="m" />
            <v-radio label="w" value="w" />
            <v-radio label="d" value="d" />
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn @click="close(true)" v-if="dialog.name!=''">Neu</v-btn>
          <v-btn @click="close(false)">Abbrechen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  name: "current",
  props: {
    keypress: {
      type: String,
      default: 'Space'
    }
  },
  data () {
    return {
      name: null,
      verein: null,
      mwd: null,
      time: null,
      running: false,
      starttime: null,
      timeout: null,
      id: null,
      platz: null,
      dialog: {
        open: false,
        name: '',
        verein: '',
        mwd: null
      },
      buzz: this.keypress
    }
  },
  computed: {
    timeformat () {
      let min = Math.floor(this.time / 60)
      let sec = this.$options.filters.float2_0(this.time - 60 * min)
      if (sec < 10) sec = '0' + sec
      return `${min}:${sec}`
    }
  },
  methods: {
    neu (neuperson) {
      if (neuperson) {
        this.dialog.name = ''
        this.dialog.verein = ''
        this.dialog.mwd = null
        this.dialog.open = true
        this.$store.state.dialogopen = true
      }

      this.time = 0
      this.running = false
      this.id = uuid()
      this.platz = null
    },
    close (neu) {
      if (neu) {
        this.name = this.dialog.name
        this.verein = this.dialog.verein !== '' ? this.dialog.verein : null
        this.mwd = this.dialog.mwd
      }

      this.dialog.open = false
      this.$store.state.dialogopen = false
    },
    save () {
      if (!this.name || !this.time || this.running) return

      this.$store.commit('add', {
        name: this.name,
        verein: this.verein,
        mwd: this.mwd,
        time: this.time,
        id: this.id
      })
    },
    bonus () {
      this.time -= 5
      if (this.time <= 0) this.time = 0
      this.update()
    },
    malus () {
      this.time += 5
      this.update()
    },
    update () {
      if (!this.name || !this.time || this.running) return

      this.$store.commit('update', {
        time: this.time,
        id: this.id
      })
    },
    buzzer (ev) {
      if(ev.code !== this.buzz || (!this.running && this.time) || this.$store.state.dialogopen) return

      if (!this.running) this.start()
      else this.stop()
    },
    start () {
      this.starttime = Date.now()
      this.running = true
      this.run()
    },
    stop () {
      this.running = false
      this.run()
      this.save()
    },
    run () {
      if (this.timeout) {
        window.clearTimeout(this.timeout)
        this.timeout = null
      }
      if (this.running) {
        this.timeout = window.setTimeout(this.run, 10)
        this.time = Math.round((Date.now() - this.starttime) / 10) / 100
        this.platz = this.$store.state.ergebnisse.filter(e => parseFloat(e.time) < parseFloat(this.time)).length + 1
      }
    }
  },
  created () {
    window.addEventListener('keydown', this.buzzer)
  },
  destroyed () {
    window.removeEventListener('keydown', this.buzzer)
  }
}
</script>

<style scoped>
  .card {
    position: relative;
  }

  .actions {
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
  }

  .time {
    font-size: 100px;
    font-weight: bold;
    line-height: 150px;
    color: black;
    text-align: center;
  }

  .platz {
    font-size: 30px;
    text-align: center;
    line-height: 50px;
  }
</style>
